<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div v-if="userPermissions.indexOf('add_location_departments') > -1" class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">{{pageTitle}}</div>
                <button type="submit" class="back_button btn btn-primary pull-right" v-on:click.prevent="buttonBack">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <form id="benefitForm">
                    <div class="forms-container">
                        <div class="row no-margin">
                            <!--Department Name-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="name">Name :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="name" type="text" class="form-control" id="name" placeholder="Name">
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{nameError}}</font>
                                </div>
                            </div>
                            <!--Department alias -->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="alias">Alias :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="alias" type="text" class="form-control" id="alias" placeholder="Alias">
                                    <!-- <div class="requiredstar">*</div> -->
                                    <!-- <font class="text-danger">{{nameError}}</font> -->
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="locationId">Location :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="locationId"
                                              multiple
                                              @change="changedValue"
                                              @input="changedValueUser()"
                                              name="locationId"
                                              id="locationId"
                                              label="text"
                                              :filterable="false"
                                              :options="locationArr"
                                              @search="onSearchCompany"
                                              placeholder="Select Location">
                                        <template slot="no-options">
                                            Search Location...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{locationIdError}}</font>
                                </div>
                            </div>
                            <!--Error Alert-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <div class="alert alert-danger" id="alertError">
                                        <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                        <strong id="errorMsg" class="error"></strong>
                                    </div>
                                </div>
                            </div>
                            <!--Buttons-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <input id="addLocationBtn" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addDepartment()">
                                    <input id="addAndContinueLocationBtn" type="submit" value="Save and Continue" class="btn btn-primary" v-on:click.prevent="addDepartment(flag='Save and Continue')">
                                    <input id="CancelLocation" type="submit" value="Cancel" class="back_button btn btn-primary" v-on:click.prevent="buttonBack">
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <!--page content-->
        </div>
        <div v-else class="container-fluid xyz">
            <div class="page-name">
                Oops...!
            </div>
            <div class="admin-page-content">
                Sorry, You don't have permission to access this page.
            </div>
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    var self;
    import vSelect from 'vue-select';
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';
    import moment from 'moment';

    import datePicker from 'vue-bootstrap-datetimepicker';
    import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

    export default {
        name: 'AddDepartments',
        pageTitle: 'Add Department',
        mixins: [SessioMixin],
        components: {
            'v-select': vSelect,
            'datePicker': datePicker,
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
                //V-model
                userPermissions: ['add_location_departments'],
                name: '',
                alias: '',
                locationId: '',
                locationArr: [],
                
                //Errors
                nameError: '',
                locationIdError: '',
            }
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
            self.pageTitle = 'Add Department';
        },
        mounted: function () {
            self.showLoader();
            /*self.loadUsers();*/
            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[2] == 'updatedepartment') {
                if (segments[3]) {
                    self.pageTitle = 'Edit Department';
                    self.loadDepartment();
                    $("#addAndContinueLocationBtn").hide();
                    $("#addLocationBtn").val("Update");
                    $("#benefitHeader").text("Edit Benefit Video");
                }
            } else {
                self.hideLoader();
            }
            
            $("#name").on('keyup', function () {
                self.nameError = '';
            });
            $("#alertError").hide();
            self.getPermissions();
            self.loadLocations();
        },
        watch: {
            
        },
        methods: {
            buttonBack() {
                $(".back_button").prop("disabled", false);
                self.$router.push('/backend/departmentlist');
            },
            changedValue: function (value) {
                //console.log(value);
            },
            changedValueUser: function () {
            },
            onSearchCompany(search, loading) {
                if (search.length > 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadLocations(loading, search, this);
                }
            },

            checkForm: function () {
                var checked = true;
                
                self.nameError = "";
                if (!self.name) {
                    self.nameError = "Name Required";
                    if (checked) {
                        checked = false;
                    }
                }
                self.locationIdError = "";
                if (self.locationId.length === 0) {
                    self.locationIdError = "Location Required";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },

            validEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },

            loadLocations(loading, search, vm) {

                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var data = {
                    search: search
                };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        search: search,
                        get_all: 1
                    }
                };
                HTTP.get("ce-getsite", config)
                        .then(function (response) {
                            self.locationArr = [];
                            self.locationArr = response.data.content;
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },

            loadDepartment() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        id: segments[3]
                    }
                };

                var data = {
                    id: segments[3],
                };
                self.showLoader();
                HTTP.get("ce-getDepartmentById", config)
                        .then(function (response) {
                            // self.locationId = response.data.content[0].location_name;
                            self.name = response.data.content.departmentName;
                            self.alias = response.data.content.departmentAlias;
                            // self.locationId = {text: response.data.content.companyName, value: response.data.content.company_id};
                            self.locationId = [];
                            for (var i = 0; i < response.data.content.location.length; i++) {
                                self.locationId.push({'text': response.data.content.location[i].name, 'value': response.data.content.location[i].id});
                            }

                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },

            addDepartment(flag) {
                self.checkForm();
                if (self.checkForm()) {
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    var locationsId = '';
                    for (var i = 0; i < self.locationId.length; i++) {
                        locationsId += (self.locationId[i].value) + ',';
                    }
                    locationsId = locationsId.replace(/,\s*$/, "");
                    if (segments[2] == 'updatedepartment') {
                        if (segments[3]) {
                            var data = {
                                name: self.name,
                                alias: self.alias,
                                locationId: locationsId,
                                id: segments[3],
                            };
                            $("#addLocationBtn").val("Updating ...");
                            $("#addLocationBtn").prop("disabled", true);
                            // $("#addAndContinueCaseBtn").prop('disabled',true);
                            $("#CancelLocation").prop("disabled", true);
                        } else {
                            if (flag == "Save and Continue") {
                                $("#addAndContinueLocationBtn").val("Saving ...");
                                $("#addAndContinueLocationBtn").prop("disabled", true);
                                $("#addLocationBtn").prop("disabled", true);
                                $("#CancelLocation").prop("disabled", true);
                            } else {
                                $("#addLocationBtn").val("Saving ...");
                                $("#addLocationBtn").prop("disabled", true);
                                $("#addAndContinueLocationBtn").prop("disabled", true);
                                $("#CancelLocation").prop("disabled", true);
                            }
                        }
                    } else {
                        var data = {
                            name: self.name,
                            alias: self.alias,
                            locationId: locationsId,
                        };
                        if (flag == "Save and Continue") {
                            $("#addAndContinueLocationBtn").val("Saving ...");
                            $("#addAndContinueLocationBtn").prop("disabled", true);
                            $("#addLocationBtn").prop("disabled", true);
                            $("#CancelLocation").prop("disabled", true);
                        } else {
                            $("#addLocationBtn").val("Saving ...");
                            $("#addLocationBtn").prop("disabled", true);
                            $("#addAndContinueLocationBtn").prop("disabled", true);
                            $("#CancelLocation").prop("disabled", true);
                        }
                    }
                    self.showLoader();
                    HTTP.post("ce-addupdatedepartment", data, config)
                            .then(function (response) {
                                if (segments[2] == 'updatedepartment') {
                                    if (segments[3]) {
                                        //console.log(segments[3]);
                                        $("#addLocationBtn").val("Update");
                                        $("#addLocationBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelLocation").prop("disabled", false);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueLocationBtn").val("Save and Continue");
                                            $("#addAndContinueLocationBtn").prop("disabled", false);
                                            $("#addLocationBtn").prop("disabled", false);
                                            $("#CancelLocation").prop("disabled", false);
                                        } else {
                                            $("#addLocationBtn").val("Save");
                                            $("#addLocationBtn").prop("disabled", false);
                                            $("#addAndContinueLocationBtn").prop("disabled", false);
                                            $("#CancelLocation").prop("disabled", false);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueLocationBtn").val("Save and Continue");
                                        $("#addAndContinueLocationBtn").prop("disabled", false);
                                        $("#addLocationBtn").prop("disabled", false);
                                        $("#CancelLocation").prop("disabled", false);
                                    } else {
                                        $("#addLocationBtn").val("Save");
                                        $("#addLocationBtn").prop("disabled", false);
                                        $("#addAndContinueLocationBtn").prop("disabled", false);
                                        $("#CancelLocation").prop("disabled", false);
                                    }
                                }

                                if (response.data.message == "success") {
                                    // self.$router.push('/task/list');
                                    $("#errorMsg").html(response.data.content);
                                    /*console.log("if");*/
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");
                                    if (flag == "Save and Continue") {
                                        // $("html, body").animate({scrollTop: "0px"}, 500);
                                        $(".alert-success").addClass("show");
                                        self.name = '';
                                        self.alias = '';
                                        self.locationId = '';
                                        self.locationArr = [];
                                        /*$("#status option[value='']").attr('selected', true);
                                         $("#type option[value='']").attr('selected', true);*/
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $(".back_button").prop("disabled", true);
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                            self.buttonBack();
                                        }, 3000);
                                    }
                                } else {
                                    $("#alertError").show();
                                    /*console.log('else');*/
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                    }
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                    }, 5000);
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                if (segments[2] == 'updatedepartment') {
                                    if (segments[3]) {
                                        $("#addLocationBtn").val("Update");
                                        $("#addLocationBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelLocation").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueLocationBtn").prop("disabled", false);
                                            $("#addAndContinueLocationBtn").val("Save and Continue");
                                            $("#addLocationBtn").prop("disabled", false);
                                            $("#CancelLocation").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            // $(".alert-success").toggleClass("show");
                                            self.name = '';
                                            self.alias = '';
                                            self.locationId = '';
                                            self.locationArr = [];
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        } else {
                                            $("#addLocationBtn").val("Save");
                                            $("#addLocationBtn").prop("disabled", false);
                                            $("#addAndContinueLocationBtn").prop("disabled", true);
                                            $("#CancelLocation").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }

                                        if (err.response.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                //EventBus.$emit("logged-in", true, "", "");
                                                self.$router.push("/login");
                                            }
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueLocationBtn").prop("disabled", false);
                                        $("#addAndContinueLocationBtn").val("Save and Continue");
                                        $("#addLocationBtn").prop("disabled", false);
                                        $("#CancelLocation").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        // $(".alert-success").toggleClass("show");
                                        self.name = '';
                                        self.alias = '';
                                        self.locationId = '';
                                        self.locationArr = [];
                                        /*$("#status option[value='']").attr('selected', true);
                                         $("#type option[value='']").attr('selected', true);*/
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $("#addLocationBtn").val("Save");
                                        $("#addLocationBtn").prop("disabled", false);
                                        $("#addAndContinueLocationBtn").prop("disabled", true);
                                        $("#CancelLocation").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }

                                    if (err.response.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }
                                }
                                self.hideLoader();
                            });
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/backend/ManageDepartments/AddDepartments.vue